import { render } from "./VNotifications.vue?vue&type=template&id=59fc39df"
import script from "./VNotifications.vue?vue&type=script&lang=js"
export * from "./VNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__